import { render } from "./DecorationProgress.vue?vue&type=template&id=af6bf18e"
import script from "./DecorationProgress.vue?vue&type=script&lang=js"
export * from "./DecorationProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__